import React from 'react'
import styles from './footer.module.css'

export default function InfoRender(props) {
    return (
        <div className={styles.infoRedner_container}>
            <img className={styles.infoRender_img} alt="infoImg" src={`/assets/icons/${props.img}.svg`} />
            <span className={styles.infoRender_text}>{props.text}</span>
        </div>
    )
}